import { TargetSource, TrackedTarget } from "@app/shared";

export function getTrackedTargetHistory(target: TrackedTarget, frame: { radar: number, video: number }) {
    const targetFrame = target.source === TargetSource.Radar ? frame.radar : frame.video;

    if (targetFrame < target.firstFrameTracked || targetFrame > target.lastFrameTracked) { return undefined; }

    if (target.targetHistory === undefined || target.targetHistory == null || target.targetHistory.length === 0) {
        console.log("No target history found for target ", target);
        return undefined;
    }

    const estFrameLocation = Math.max(Math.min(targetFrame - target.firstFrameTracked, target.targetHistory.length - 1), 0);
    //Try to optimize the search by starting with the estimated frame location and searching outwards
    for (var i = 0; (estFrameLocation + i) < target.targetHistory.length || (estFrameLocation - i) >= 0; i++) {
        //Check the forward history first
        if (estFrameLocation + i < target.targetHistory.length && target.targetHistory[estFrameLocation + i].frameNumber === targetFrame) {
            return target.targetHistory[estFrameLocation + i];
        }
        if (i === 0) { continue; }
        //Check the backward history
        if (estFrameLocation - i >= 0 && target.targetHistory[estFrameLocation - i].frameNumber === targetFrame) {
            return target.targetHistory[estFrameLocation - i];
        }
    }
    return undefined;
}
export function getTrackedTargetHistoryIndex(target: TrackedTarget, frame: { radar: number, video: number }) {
    const targetFrame = target.source === TargetSource.Radar ? frame.radar : frame.video;

    if (targetFrame < target.firstFrameTracked || targetFrame > target.lastFrameTracked) { return undefined; }

    if (target.targetHistory === undefined || target.targetHistory == null || target.targetHistory.length === 0) { return undefined; }

    const estFrameLocation = Math.max(Math.min(targetFrame - target.firstFrameTracked, target.targetHistory.length - 1), 0);
    //Try to optimize the search by starting with the estimated frame location and searching outwards
    for (var i = 0; (estFrameLocation + i) < target.targetHistory.length || (estFrameLocation - i) >= 0; i++) {
        //Check the forward history first
        if (estFrameLocation + i < target.targetHistory.length && target.targetHistory[estFrameLocation + i].frameNumber === targetFrame) {
            return target.targetHistory[estFrameLocation + i];
        }
        if (i === 0) { continue; }
        //Check the backward history
        if (estFrameLocation - i >= 0 && target.targetHistory[estFrameLocation - i].frameNumber === targetFrame) {
            return target.targetHistory[estFrameLocation - i];
        }
    }
    return undefined;
}
